var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Field / Clear"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.8574 4.3454C14.1038 0.601012 7.9439 0.601012 4.19024 4.3454C0.436585 8.08979 0.436585 14.2344 4.19024 17.9788C7.9439 21.7232 14.0075 21.7232 17.7612 17.9788C21.5148 14.2344 21.6111 8.08979 17.8574 4.3454ZM13.7188 15.1945L11.0238 12.5062L8.3289 15.1945L6.98143 13.8504L9.67636 11.1621L6.98143 8.47383L8.3289 7.12969L11.0238 9.81797L13.7188 7.12969L15.0662 8.47383L12.3713 11.1621L15.0662 13.8504L13.7188 15.1945Z",
    fill: "#939AA8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.9bb9f1ddfc80d38254334187ea5b463a.svg";
export { ForwardRef as ReactComponent };